import { attr, belongsTo, hasMany } from '@warp-drive/legacy/model';

import Model from 'umg-ember-backend/models/variant-model';
import {
  buildValidations,
  disabledWhenVariant,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  aDateStart: validator('presence', {
    presence: true,
    disabled: disabledWhenVariant(),
  }),
  headline: validator('presence', true),
  text: validator('presence', true),
  artists: [
    validator('has-many'),
    validator('presence', {
      presence: true,
      disabled: disabledWhenVariant(),
    }),
  ],
});

export const settings = {
  copyableOptions: {
    ignoreAttributes: [
      'channelsAdditive',
      'channelsExcluded',
      'channelsExclusive',
      'ownedByChannel',
    ],
  },
  variantProperties: [
    'cmsLanguageId',
    'cmsState',
    'errorMessage',
    'headline',
    'questionaireText',
    'sharingText',
    'smsText',
    'solicitableText',
    'subHeadline',
    'teaserHeadline',
    'teaserText',
    'text',
    'thxMessage',
    'tosText',
    'wonText',
  ],
};

export default class ActionModel extends Model.extend(Validations) {
  @attr aDateEnd;
  @attr aDateStart;
  @attr('string') cgCompetitionId;
  @attr('string') contactFormRecipient;
  @attr('string') errorMessage;
  @attr('string') headline;
  @attr('boolean') isContactForm;
  @attr('string') questionaireText;
  @attr('string') sharingText;
  @attr('string') smsText;
  @attr('string') solicitableText;
  @attr('string') teaserHeadline;
  @attr('string') teaserText;
  @attr('string') text;
  @attr('string') thxMessage;
  @attr('string') tosText;
  @attr('string', { defaultValue: 'CG' }) type;
  @attr('string') userDetailMode;
  @attr('string') wonText;

  // CMS fields
  @attr('number', { defaultValue: 2 }) cmsState;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Relations
  @hasMany('artist', { async: true, inverse: null }) artists;
  @belongsTo('asset', { async: true, inverse: null }) asset;
  @hasMany('asset', { async: true, inverse: null }) assets;
  @hasMany('channel', { async: true, inverse: null }) channelsAdditive;
  @hasMany('channel', { async: true, inverse: null }) channelsExcluded;
  @hasMany('channel', { async: true, inverse: null }) channelsExclusive;

  // Getter and setter
  get displayHeadline() {
    return this.headline;
  }

  get displayLabel() {
    return this.headline;
  }
}
